import React from "react";
import { useTheme } from "@mui/material";
import { useState } from "react";
import Space from "../layout/Space";
import Icon1 from "../icons/Icon";
import CheckBoxGrey from "../textfields/CheckBoxGrey";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isColorTooDark } from "../models/OrgFunctions";
import SecondaryButton from "../buttons/SecondaryButton";

const TagFilter = ({
  orgData,
  setTagFilters,
  onClose,
  folders_config,
  navigateWorkspace,
}) => {
  const intToHexColor = (colorint) => {
    // Extract ARGB components
    const alpha = (colorint >> 24) & 0xff;
    const red = (colorint >> 16) & 0xff;
    const green = (colorint >> 8) & 0xff;
    const blue = colorint & 0xff;

    // Convert each component to a 2-digit hex value and combine them
    return `#${[red, green, blue].map((c) => c.toString(16).padStart(2, "0")).join("")}`;
  };

  useEffect(() => {
    if (folders_config && folders_config.tags_filters) {
      setSelectedTags(folders_config.tags_filters);
    } else {
      let selected_tags = orgData.tags?.map((tag) => tag.nom) || [];
      selected_tags.push("Pas de tag");
      selected_tags.push("#nouveau");
      setSelectedTags([]);
    }
  }, [orgData]);

  const handleSetTagFIlters = (tag_nom) => {
    if (selectedTags.includes(tag_nom)) {
      setSelectedTags(selectedTags.filter((tag) => tag !== tag_nom));
      setTagFilters(selectedTags.filter((tag) => tag !== tag_nom));
    } else {
      setSelectedTags([...selectedTags, tag_nom]);
      setTagFilters([...selectedTags, tag_nom]);
    }
  };

  const theme = useTheme();

  const [tags_hover, setTagsHover] = useState({});
  const [selectedTags, setSelectedTags] = useState([]);

  return (
    <div className="text-xs bg-white text-white rounded-3xl h-fit w-c500 flex p-4 flex-col gap-2">
      <div className="flex flex-row flex-grow w-full justify-start gap-2">
        {" "}
        <div className="text-h1 text-black">Filtrez par tag</div>
        <div
          className="w-fil cursor-pointer"
          onClick={() => navigateWorkspace("/tags")}
        >
          <Icon1 icon_name="settings" height="20px" width="20px" />
        </div>
        <div
          className="cursor-pointer flex flex-grow justify-end"
          onClick={onClose}
        >
          {" "}
          <Icon1 icon_name="close" height="20px" width="20px" fill="grey" />
        </div>
      </div>
      <Space y={5} />
      <div className="text-h3 text-shadow_50">
        Seuls les dossiers contenant <span className="font-bold">TOUS</span> les
        tags sélectionnés seront affichés
      </div>{" "}
      <Space y={5} />
      <div className="flex flex-row gap-2">
        {" "}
        <SecondaryButton
          className="w-fit"
          onClick={() => {
            setTagFilters([]);
            setSelectedTags([]);
          }}
        >
          Tout décocher
        </SecondaryButton>
        <SecondaryButton
          className="w-fit"
          onClick={() => {
            let selected_tags = orgData.tags?.map((tag) => tag.nom) || [];
            selected_tags.push("Pas de tag");
            selected_tags.push("#nouveau");
            setSelectedTags(selected_tags);
            setTagFilters(selected_tags);
          }}
        >
          Tout cocher
        </SecondaryButton>
      </div>
      <div className="flex flex-wrap">
        <div
          key="pas de tag"
          className=" flex flex-row rounded-xl gap-2 pr-2 pl-1 py-0.5  m-1 w-fit h-fit font-light cursor-pointer items-center text-h2"
          style={{
            backgroundColor: tags_hover["pas de tag"]
              ? theme.palette.shadow._25
              : theme.palette.shadow._10,

            color: "black",
          }}
        >
          {" "}
          <CheckBoxGrey
            checked={selectedTags.includes("Pas de tag")}
            onChange={() => handleSetTagFIlters("Pas de tag")}
          />
          Pas de tag
        </div>
        <div
          key="#nouveau"
          className=" flex flex-row rounded-xl gap-2 pr-2 pl-1 py-0.5  m-1 w-fit h-fit font-light cursor-pointer items-center text-h2"
          style={{
            backgroundColor: tags_hover["#nouveau"]
              ? theme.palette.shadow._25
              : "#d9f0ff",

            color: "black",
          }}
        >
          {" "}
          <CheckBoxGrey
            checked={selectedTags.includes("#nouveau")}
            onChange={() => handleSetTagFIlters("#nouveau")}
          />
          #nouveau
        </div>
        {orgData.tags
          ?.sort((a, b) => a.nom.localeCompare(b.nom))
          .map((tag, index) => (
            <div
              key={index}
              className=" flex flex-row rounded-xl gap-2 pr-2 pl-1 py-0.5  m-1 w-fit h-fit font-light cursor-pointer items-center text-h2"
              style={{
                backgroundColor: tags_hover[tag.nom]
                  ? theme.palette.shadow._25
                  : intToHexColor(tag.colorint),
                color: isColorTooDark(intToHexColor(tag.colorint))
                  ? "white"
                  : "black",
              }}
            >
              <CheckBoxGrey
                checked={selectedTags.includes(tag.nom)}
                onChange={() => handleSetTagFIlters(tag.nom)}
              />
              {tag.nom}
            </div>
          ))}
      </div>
    </div>
  );
};

export default TagFilter;
